module.exports = __webpack_public_path__ + "static/media/navyBin.e11c0db6.svg";